import {
  FeatureName,
  FeatureInteraction,
} from 'packages/openclassrooms/openclassrooms-sdk-web/src';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface UpdateFeatureInteraction {
  userId: number;
}

const { useUpdate: useUpdateFeatureInteraction } = getCRUDHooks<
  FeatureInteraction,
  any,
  any,
  any,
  UpdateFeatureInteraction
>({
  entityName: 'featureInteraction',
  update(name: FeatureName, { userId }: UpdateFeatureInteraction) {
    const client = clientApi.getOCClient().helpers.user.users.id(userId);
    return client.featureInteractions.update('', { name });
  },
});

export { useUpdateFeatureInteraction };
